// import firebase from "./firebase"
// import './App.css';
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle";
// import { BrowserRouter as Router, Routes, Route  } from 'react-router-dom';
// import Home from './Home';
// import Navbar from './Navbar';
// import Contact from './Contact';
// import PushNotification from "./PushNotification";
// import Blogs from './Blogs';
// import Gallery from './Gallery';
// import About from './About';
// import Foot from './Foot';
// import ThemeProvider from "./Dark";

// import "./theme.css";
// import Login from './Login';
// import Register from './Register';
// import Video from "./Video";
// import Note from "./Note";
// import Hack from "./Hack";
// import ResetPassword from "./ResetPassword";
// import AdminLogintracker from "./AdminLogintracker";
// import Projects from "./Projects";
// import Chatbot from "./Chatbot";
// import Resume from "./Resume";
// import TermsOfService from "./TermsofServices";
// import RealtimeGaDashboard from "./RealtimeGaDashboard";
// import Code from "./Code";
// import Services from "./Services";
// import Products from "./Products";
// import Loader from "./Loader";




// function App() {
//   return (
//     <Router>
//     <Routes>
//     <Route path='/' element={<Home />} />
//     <Route path='/Navbar' element={<Navbar/>} />
//     <Route path='/Contact' element={<Contact/>} />
//     <Route path='/Blogs' element={<Blogs/>} />
//     <Route path='/Gallery' element={<Gallery/>} />
//     <Route path='/Foot' element={<Foot/>} />
//     <Route path='/Login' element={<Login/>} />
//     <Route path='/About' element={<About/>} />
//     <Route path='/Note' element={<Note/>} />
//     {/* <Route path='/Dark' element={<Dark/>} /> */}
// <Route path='/Hack' element={<Hack />}/>
//     <Route path='/Register' element={<Register/>} />
//     <Route path='/Video' element={<Video />} />
//     <Route path="/admin/logins" element={<AdminLogintracker />} />

//     <Route path="/Chatbot" element={<Chatbot />} />
//         <Route path="/Projects" element={<Projects />} />
//      {/* <Route path="/Resume" element={<Resume />} /> */}
//      <Route path="/terms" element={<TermsOfService />} />
//      <Route path="/codeupload" element={<Code />} />


// <Route path="/products" element={<Products />} />
// <Route path="/loader" element={<Loader />} />
    
// <Route path="/ResetPassword" element={<ResetPassword />} />
// <Route path="/push-notifications" element={<PushNotification/>} />
// <Route path="/real-time-dashboard" element={<RealtimeGaDashboard/>} />
// <Route path="/services" element={<Services/>} />



//     </Routes>
//   </Router>
  
//   );
// }

// export default App;


import React from "react";
import "./App.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import Home from "./Home";
import Navbar from "./Navbar";
import Contact from "./Contact";
import PushNotification from "./PushNotification";
import Blogs from "./Blogs";
import Gallery from "./Gallery";
import About from "./About";
import Foot from "./Foot";
import ThemeProvider from "./Dark";

import "./theme.css";

import Login from "./Login";
import Register from "./Register";
import Video from "./Video";
import Note from "./Note";
import Hack from "./Hack";
import ResetPassword from "./ResetPassword";
import AdminLogintracker from "./AdminLogintracker";
import Projects from "./Projects";
import Chatbot from "./Chatbot";
import Resume from "./Resume";
import TermsOfService from "./TermsofServices";
import RealtimeGaDashboard from "./RealtimeGaDashboard";
import Code from "./Code";
import Services from "./Services";
import Products from "./Products";
import Loader from "./Loader";

import ProtectedRoute from "./ProtectedRoute";


function App() {
  return (
    <Router>
      <Routes>

        {/* =====================================================
            PUBLIC ROUTES
            These pages can be opened without login
        ===================================================== */}

        <Route path="/" element={<Home />} />

        <Route path="/Login" element={<Login />} />

        <Route path="/Register" element={<Register />} />

        <Route path="/ResetPassword" element={<ResetPassword />} />

        <Route path="/terms" element={<TermsOfService />} />


        {/* =====================================================
            PROTECTED ROUTES
            User must be logged in
        ===================================================== */}

        <Route element={<ProtectedRoute />}>

          <Route path="/Navbar" element={<Navbar />} />

          <Route path="/Contact" element={<Contact />} />

          <Route path="/Blogs" element={<Blogs />} />

          <Route path="/Gallery" element={<Gallery />} />

          <Route path="/Foot" element={<Foot />} />

          <Route path="/About" element={<About />} />

          <Route path="/Note" element={<Note />} />

          <Route path="/Hack" element={<Hack />} />

          <Route path="/Video" element={<Video />} />

          <Route path="/Chatbot" element={<Chatbot />} />

          <Route path="/Projects" element={<Projects />} />

          <Route path="/codeupload" element={<Code />} />

          <Route path="/products" element={<Products />} />

          <Route path="/loader" element={<Loader />} />

          <Route path="/push-notifications" element={<PushNotification />} />

          <Route
            path="/real-time-dashboard"
            element={<RealtimeGaDashboard />}
          />

          <Route path="/services" element={<Services />} />

          {/* Add Resume here if you want it protected */}
          {/* <Route path="/Resume" element={<Resume />} /> */}

        </Route>


        {/* =====================================================
            ADMIN ROUTE
            You can protect this separately later with an
            admin-specific route guard.
        ===================================================== */}

        <Route
          path="/admin/logins"
          element={<AdminLogintracker />}
        />

      </Routes>
    </Router>
  );
}

export default App;
